import React from 'react';
import { connect } from 'react-redux';
import dayjs from 'dayjs';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';

import StravaCard from './stravaCard';
import TimerWidget from './timerWidget';

import { getTrainings, getEvents } from 'reducers/selectors';

const Training = ({ trainings, events }) => (
    <div className="training-content">
        <h2 style={{ textAlign: 'center' }}>Click Things, Learn Stuff</h2>
        <div className="training-cards grid grid-cols-1 md:grid-cols-[2fr_1fr] gap-8 mb-8">
            <div>
                <h3 style={{ textAlign: 'center' }}>Professional</h3>
                <div className="training-cards grid grid-cols-1 md:grid-cols-2 gap-3 mb-8">
                    {trainings.length > 0 &&
                        trainings.map(training => (
                            <Card sx={{ width: 345 }} key={training.id}>
                                <CardActionArea
                                    component="a"
                                    href={
                                        training.url ||
                                        `/Training/${encodeURIComponent(
                                            training.id
                                        )}`
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <CardMedia
                                        component="img"
                                        height="200"
                                        src={`/content/trainingContent/thumbnails/${training?.thumbnailLocation}`}
                                        alt={`${training?.title} Thumbnail`}
                                    />
                                    <CardContent>
                                        <Typography
                                            gutterBottom
                                            variant="h5"
                                            component="div"
                                        >
                                            {training.title}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        ))}
                </div>
                {trainings.length === 0 && (
                    <div>
                        I am currently working on this section, check back later
                        for some interesting content
                    </div>
                )}
            </div>
            <div>
                <h3 style={{ textAlign: 'center' }}>Personal</h3>
                <div className="training-cards grid grid-cols-1 md:grid-cols-1 mb-8">
                    <h5>Check out my last training session</h5>
                    <StravaCard />

                    <h5>Upcoming Events</h5>
                    {events.length > 0 ? (
                        events.map((ev, index) => {
                            let colorStyle;

                            if (ev.color1 && ev.color2 && ev.color3) {
                                colorStyle = {
                                    background: `linear-gradient(137deg, ${ev.color1}, ${ev.color2}, ${ev.color3})`,
                                };
                            } else if (ev.color1 && ev.color2) {
                                colorStyle = {
                                    background: `linear-gradient(137deg, ${ev.color1}, ${ev.color2})`,
                                };
                            } else if (ev.color1) {
                                colorStyle = {
                                    backgroundColor: `${ev.color1}`,
                                };
                            } else {
                                colorStyle = {
                                    backgroundColor: '#082449',
                                };
                            }

                            return (
                                <TimerWidget
                                    date={dayjs(ev.startDate)}
                                    dateLabel={ev.dateLabel}
                                    link={ev.link}
                                    img={`data:image/png;base64,${ev?.img}`}
                                    // img="https://www.rundisney.com/events/disneyworld/springtime-surprise-weekend/events/media_1bf2368f508075ff53886887a05615fa0d5341c23.png?width=2000&format=webply&optimize=small"
                                    title={ev.name}
                                    sponsor={ev.sponsor}
                                    key={`e${index}`}
                                    style={colorStyle}
                                />
                            );
                        })
                    ) : (
                        <div>
                            I am currently looking for my next challenge, check
                            back later to see what I pick
                        </div>
                    )}
                    {/* <TimerWidget
                        date={new Date(2027, 3, 8, 5, 0, 0)}
                        dateLabel="April 8 - 11, 2027"
                        link="https://www.rundisney.com/events/disneyworld/springtime-surprise-weekend"
                        img="https://www.rundisney.com/events/disneyworld/springtime-surprise-weekend/events/media_1bf2368f508075ff53886887a05615fa0d5341c23.png?width=2000&format=webply&optimize=small"
                        title="Springtime Surprise Challenge"
                        sponsor="Supporting Make-A-Wish"
                        bgClass="orange"
                    /> */}
                </div>
            </div>
        </div>
    </div>
);

export default connect(state => {
    return {
        trainings: getTrainings(state),
        events: getEvents(state),
    };
}, null)(Training);
